<template>
  <div class="scope-items-list">
    <template v-if="items && items.length">
      <div class="scope-item" :key="`item_${i}`" v-for="(item, i) in items">
        <p>{{ item.name }}</p>
        <div class="icons-container">
          <a class="icon-container" @click="edit(item)">
            <i class="bdg-icon edit text-red" />
          </a>
          <a class="icon-container" @click="remove(item)">
            <i class="bdg-icon trash text-red" />
          </a>
        </div>
      </div>
    </template>
    <div class="empty-state" v-else>
      No items to show
    </div>
  </div>
</template>

<script>
import ScopeItemForm from "../../forms/ScopeItemForm";

export default {
  name: "ScopeItemsList",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    edit(item) {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: ScopeItemForm,
        createEditComponentData: item,
        createEditComponentIsShown: true
      });
    },
    remove(item) {
      this.$store.dispatch("deleteScopeItem", item);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/assets";

.scope-items-list {
  .scope-item {
    @apply flex justify-between px-4 py-3;
    @include striped($light: true);

    .icons-container {
      .icon-container {
        &:not(:first-child) {
          @apply ml-6;
        }
      }
    }
  }
}
</style>
